export default __webpack_public_path__ + "static/media/F37Stout-BoldExpanded.cf0bf5ce.woff";